export default {
  DISCOUNT_FEEDBACK: 'survey:KTJ1HFNh6a',
  PREALLOCATION_FEEDBACK: 'survey:NUJP8WtsOw',
};
